import apiAxios from './axios'

const urlPrefix='im/common/'

/**
 * 查询用户
 * @returns {AxiosPromise}
 */
export function userInfoApi(id) {
    return apiAxios({
        url: urlPrefix+'checkUserLogin',
        method: 'post',
        data: {id: id}
    })
}

/**
 * 获取用户Im信息
 * @param userId 用户id
 * @param JobfairId 招聘会id
 * @returns {*}
 */
export function imUserInfoApi(userId,jobfairId) {
    return apiAxios({
        url: urlPrefix+'getUserInfo',
        method: 'post',
        data: {
            userId:userId,
            JobfairId:jobfairId
        }
    })
}

/**
 * 查询招聘会详情
 * @param id 招聘会id
 * @returns {AxiosPromise}
 */
export function jobfairInfoApi(id) {
    return apiAxios({
        url: 'im/common/queryJobfairDetails',
        method: 'post',
        data: {id: id}
    })
}

/**
 * 获取用户信息
 * @param userId
 * @param meId
 * @returns {AxiosPromise}
 */
export function userinfo(userId,meId) {
    return apiAxios({
        url: urlPrefix+'chatNetUserInfo',
        method: 'post',
        data: {
            userId:userId,
            meId:meId,
        }
    })
}

/**
 * 结束洽谈并评价
 * @param userId
 * @param toUserId
 * @param talk_id
 * @param evaluate_id
 * @param evaluate_status
 * @returns {AxiosPromise}
 */
export function talkEnd(userId,toUserId,talk_id,evaluate_id,evaluate_status) {
    return apiAxios({
        url: urlPrefix+'chatNetTalkEnd',
        method: 'post',
        data: {
            userId:userId,
            toUserId:toUserId,
            talk_id:talk_id,
            evaluate_id:evaluate_id,
            evaluate_status:evaluate_status,
        }
    })
}

/**
 * 获取简历详情
 * @param resumeId
 * @returns {*}
 */
export function resumeDetail(resumeId,is_temp) {
    return apiAxios({
        url: urlPrefix+'resumeDetail',
        method: 'post',
        data: {
            resume_id:resumeId,
            is_temp:is_temp
        }
    })
}

/**
 * 获取职位详情
 * @param jobsId
 * @returns {*}
 */
export function jobsDetail(jobsId,is_temp) {
    return apiAxios({
        url: urlPrefix+'jobsDetail',
        method: 'post',
        data: {
            job_id:jobsId,
            is_temp:is_temp
        }
    })
}

export function companyDetail(companyId) {
    return apiAxios({
        url: urlPrefix+'companyDetail',
        method: 'post',
        data: {
            company_id:companyId,
        }
    })
}

/**
 * 发送留言消息
 * @param jobfair_id
 * @param userId
 * @param toUserId
 * @param userType
 * @param msg
 * @returns {*}
 */
export function sendOfflineMes(jobfair_id,userId,toUserId,userType,msg) {
    return apiAxios({
        url: urlPrefix+'sendOfflineMes',
        method: 'post',
        data: {
            msg:msg,
            jobfairId: jobfair_id,
            userId:userId,
            toUserId:toUserId,
            userIdType:'int',
            userType:userType,
        }
    })
}


export function login(paramsList) {
    return apiAxios({
        url: '/api/login',
        method: 'post',
        data: paramsList
    })
}
